import { SvgComponentProps } from "@/src/types/SVGPropType"
import * as React from "react"
const MetaPlusSVG: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    {...props}
  >
    <path
      fill="url(#a)"
      d="m1 7.105.021.006a7.639 7.639 0 0 1 5.98 5.959c0 .003.003.008.004.011v.003c.098.373.191.386.29.04a7.636 7.636 0 0 1 5.976-6.009l.003-.001c.38-.1.387-.194.018-.295A7.637 7.637 0 0 1 7.296.81V.807c-.094-.33-.184-.328-.278.004l-.005.02L6.99.92 6.99.924l-.032.146-.003.013A7.638 7.638 0 0 1 1.338 6.75c-.002 0-.005 0-.008.002a5.46 5.46 0 0 1-.274.06h-.002l-.011.003-.003.001c-.373.098-.386.19-.04.288v.002Z"
    />
    <defs>
      <radialGradient
        id="a"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(16.53415 -12.81411 6.15192 7.93787 -1.937 10.998)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.271} stopColor="#DFDCFF" />
        <stop offset={1} stopColor="#A69EFF" />
      </radialGradient>
    </defs>
  </svg>
)
export default MetaPlusSVG
